var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponent1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_967_2149)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_967_2149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_967_2149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5808 16.7538L17.3038 10.0307L16.25 8.977L10.5808 14.6463L7.73075 11.7963L6.677 12.85L10.5808 16.7538ZM12.0017 22C10.6877 22 9.45267 21.7507 8.2965 21.252C7.14033 20.7533 6.13467 20.0766 5.2795 19.2218C4.42433 18.3669 3.74725 17.3617 3.24825 16.206C2.74942 15.0503 2.5 13.8156 2.5 12.5017C2.5 11.1877 2.74933 9.95267 3.248 8.7965C3.74667 7.64033 4.42342 6.63467 5.27825 5.7795C6.13308 4.92433 7.13833 4.24725 8.294 3.74825C9.44967 3.24942 10.6844 3 11.9983 3C13.3123 3 14.5473 3.24933 15.7035 3.748C16.8597 4.24667 17.8653 4.92342 18.7205 5.77825C19.5757 6.63308 20.2528 7.63833 20.7518 8.794C21.2506 9.94967 21.5 11.1844 21.5 12.4983C21.5 13.8123 21.2507 15.0473 20.752 16.2035C20.2533 17.3597 19.5766 18.3653 18.7218 19.2205C17.8669 20.0757 16.8617 20.7528 15.706 21.2518C14.5503 21.7506 13.3156 22 12.0017 22ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2667 19.225 8.375 17.675 6.825C16.125 5.275 14.2333 4.5 12 4.5C9.76667 4.5 7.875 5.275 6.325 6.825C4.775 8.375 4 10.2667 4 12.5C4 14.7333 4.775 16.625 6.325 18.175C7.875 19.725 9.76667 20.5 12 20.5Z",
    fill: "#102E7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_967_2149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent1);
export default __webpack_public_path__ + "static/media/Component 1.69963f6aeb13b32a8cb3a9ebe318ad2f.svg";
export { ForwardRef as ReactComponent };